import { useEffect, useState } from 'react'
import { Box, Link, Text, Flex, HStack } from '@chakra-ui/react'
import CustomRadio from '@!/Store/Common/components/CustomRadio'
import CreditCardFormContainer from '@!/Store/Purchase/containers/CreditCardFormContainer'
import { useAtom } from 'jotai'
import { userUsableCoinsAtom } from '@!/atoms/userInfoAtom'
import { SecondaryButton, NormalButton } from '@!/components/Button'
import { getPreviousPaymentMethod, removePreviousPaymentMethod } from '@!/Util/localStorageData'
import { isBlank } from '@!/Util'

const PaymentMethod = ({ hasCardInfo, cardInfo, selectedPaymentMethod, setSelectedPaymentMethod, isDisabled }) => {
  const [showCoin, setShowCoin] = useState(true)
  const [showCredit, setShowCredit] = useState(true)
  const showChangeMethodLink = showCoin !== showCredit
  const [showNewCardForm, setShowNewCardForm] = useState(false)
  const [userUsableCoins] = useAtom(userUsableCoinsAtom)
  const [previousPaymentMethod, setPreviousPaymentMethod] = useState(null)

  useEffect(() => {
    const method = getPreviousPaymentMethod()
    if (!cardInfo || isBlank(method)) return

    // 前回の支払い方法がクレジットカードで、
    // カード情報がない場合に前回の支払い方法を削除
    if (method === 'credit' && !hasCardInfo) {
      removePreviousPaymentMethod()
      setPreviousPaymentMethod(null)
      return
    }

    setPreviousPaymentMethod(method)
    setSelectedPaymentMethod(method)
  }, [cardInfo, hasCardInfo])

  useEffect(() => {
    if (selectedPaymentMethod === 'credit' && !hasCardInfo) {
      setShowNewCardForm(true)
    }
  }, [selectedPaymentMethod, hasCardInfo])

  useEffect(() => {
    // 前回の決済手段なし
    // → コインとクレジットカードの両方を表示

    if (previousPaymentMethod === 'coin') {
      // 前回の決済手段 = コイン
      // → コインを初期表示、クレジットカードは非表示
      setShowCoin(true)
      setShowCredit(false)
    } else if (previousPaymentMethod === 'credit') {
      // 前回の決済手段 = クレジット
      // クレジットカードを初期表示、コインは非表示
      setShowCoin(false)
      setShowCredit(true)
    }
  }, [previousPaymentMethod, cardInfo])
  // cardInfo の登録・変更時に previousPaymentMethod に 'credit' をセットしているため、
  // cardInfo の変更も依存に含めて登録後はクレジットカードが初期表示されるようにしている

  const handlePaymentMethodChange = (value) => {
    setSelectedPaymentMethod(value)
  }

  // カード情報を変更する
  const handleChangeCardInfo = (e) => {
    e.preventDefault()
    setShowNewCardForm(true)
  }

  // 決済方法を変更する
  const handleChangePaymentMethod = () => {
    setShowCoin(true)
    setShowCredit(true)
  }

  const changeMethodLink = (
    <Box textAlign="center" marginTop="13px">
      <Link href="#" onClick={isDisabled ? null : handleChangePaymentMethod}>
        決済方法を変更する
      </Link>
    </Box>
  )

  return (
    <>
      {/* コイン決済 */}
      {showCoin && (
        <Box pointerEvents={isDisabled ? 'none' : 'auto'} p={4} bgColor="bg.primary" border="1px solid #e0e0e0" borderRadius="base">
          <Flex onClick={() => handlePaymentMethodChange('coin')} opacity={isDisabled ? 0.5 : 1}>
            <CustomRadio isChecked={selectedPaymentMethod === 'coin'} />
            <Text mx={2}>コイン（保有コイン{userUsableCoins} Ⅽ）</Text>
          </Flex>

          <HStack spacing={3} h="37px" mt={5} mb={1}>
            <SecondaryButton as="a" href="/user/payment#/monthly_course" height="100%" isDisabled={isDisabled}>
              月額コース
            </SecondaryButton>

            <NormalButton as="a" href="/user/payment#/coin" height="100%" isDisabled={isDisabled}>
              追加購入
            </NormalButton>
          </HStack>

          {showChangeMethodLink && changeMethodLink}
        </Box>
      )}

      {/* クレジットカード決済 */}
      {showCredit && (
        <Box pointerEvents={isDisabled ? 'none' : 'auto'} p={4} bgColor="bg.primary" border="1px solid #e0e0e0" borderRadius="base">
          <Flex onClick={() => handlePaymentMethodChange('credit')} opacity={isDisabled ? 0.5 : 1}>
            <CustomRadio isChecked={selectedPaymentMethod === 'credit'} />
            <Text mx={2}>クレジットカード</Text>
            {hasCardInfo && <Box marginLeft="auto">{cardInfo.number.slice(-4)}</Box>}
          </Flex>

          {showChangeMethodLink && changeMethodLink}

          {!showChangeMethodLink && selectedPaymentMethod === 'credit' && hasCardInfo && (
            <Box textAlign="center" marginTop="13px">
              <Link href="#" onClick={handleChangeCardInfo}>
                カード情報を変更する
              </Link>
            </Box>
          )}

          {/* カード入力フォーム */}
          {showNewCardForm && selectedPaymentMethod === 'credit' && <CreditCardFormContainer setShowNewCardForm={setShowNewCardForm} />}
        </Box>
      )}
    </>
  )
}

export default PaymentMethod
